export abstract class UriHelper {
  static IsAsciiLetter(character: string): boolean {
    const characterAscii = character.charCodeAt(0);
    return (characterAscii - 'A'.charCodeAt(0) & ~0x20) < 26;
  }

  static IsAsciiLetterOrDigit(character: string): boolean {
    const characterAscii = character.charCodeAt(0);
    return (((characterAscii - 'A'.charCodeAt(0)) & ~0x20) < 26) ||
      ((characterAscii - '0'.charCodeAt(0)) < 10);
  }
}
